import React from "react";
import { Card, CardContent, Stack, Typography, Box } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

interface Props {
  label: string;
  value: React.ReactNode;
  delta?: string;          // e.g. "20%"
  deltaNote?: string;      // e.g. "vs. last Tuesday"
  deltaColor?: "success" | "warning" | "error";
  icon: React.ReactElement;
  iconBg: string;
  iconColor: string;
}

const StatCard: React.FC<Props> = ({ label, value, delta, deltaNote, deltaColor = "success", icon, iconBg, iconColor }) => (
  <Card sx={{ height: "100%" }}>
    <CardContent>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Typography variant="body2" color="text.secondary">{label}</Typography>
        <Box sx={{ bgcolor: iconBg, color: iconColor, width: 34, height: 34, borderRadius: 1.5, display: "grid", placeItems: "center" }}>
          {icon}
        </Box>
      </Stack>
      <Typography variant="h4" sx={{ mt: 1, fontWeight: 800 }}>{value}</Typography>
      {(delta || deltaNote) && (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5 }}>
          {delta && (
            <Typography variant="caption" sx={{ color: `${deltaColor}.main`, fontWeight: 700, display: "flex", alignItems: "center" }}>
              <ArrowUpwardIcon sx={{ fontSize: 14 }} />{delta}
            </Typography>
          )}
          {deltaNote && <Typography variant="caption" color="text.secondary">{deltaNote}</Typography>}
        </Stack>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
